var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import id from "@irati/utils/id";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import sagaService from "@irati/deals/services/perks-saga";
import { hitLimits } from "@irati/checkout/utils/deal/getLimits";
import withBasket from "@irati/checkout/utils/basket/withBasket";
import QuantityPicker from "../../ui/QuantityPicker/QuantityPicker";
import { Error, Label, ItemWrapper } from "./styled";
var QuantityItem = /** @class */ (function (_super) {
    __extends(QuantityItem, _super);
    function QuantityItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            stockTotals: {},
            reachedMaxPrice: false,
            reachedMaxProducts: false,
            reachedMaxItems: false
        };
        /**
         * calculates out of stock from {stock, basket} store & product prop
         * @returns {boolean}
         */
        _this.isOutOfStock = function () {
            var _a;
            var _b = _this.props, product = _b.product, basket = _b.basket;
            var stockTotals = _this.state.stockTotals;
            var countForProduct = ((_a = basket.items.find(function (item) { return item.productId === product.uuid; })) === null || _a === void 0 ? void 0 : _a.count) || 0;
            return stockTotals[product.uuid] <= countForProduct;
        };
        /**
         * calculates low in stock from {stock} store & product prop
         * @returns {boolean}
         */
        _this.isLowInStock = function () {
            var product = _this.props.product;
            var stockTotals = _this.state.stockTotals;
            return stockTotals[product.uuid] <= 10;
        };
        _this.isDisabled = function () {
            var _a = _this.state, reachedMaxPrice = _a.reachedMaxPrice, reachedMaxProducts = _a.reachedMaxProducts, reachedMaxItems = _a.reachedMaxItems;
            return (reachedMaxPrice ||
                reachedMaxProducts ||
                reachedMaxItems ||
                _this.isOutOfStock());
        };
        return _this;
    }
    QuantityItem.getDerivedStateFromProps = function (props) {
        var items = props.basket.items;
        var _a = hitLimits(props.deal), reachedMaxPrice = _a.reachedMaxPrice, reachedMaxProducts = _a.reachedMaxProducts, reachedMaxItems = _a.reachedMaxItems;
        var igoreThisProductReachedMaxProducts = reachedMaxProducts && !items.find(function (t) { return t.productId === props.product.uuid; });
        return { reachedMaxPrice: reachedMaxPrice, reachedMaxProducts: igoreThisProductReachedMaxProducts, reachedMaxItems: reachedMaxItems };
    };
    QuantityItem.prototype.componentDidMount = function () {
        var _this = this;
        sagaService.stockCount(this.props.deal.uuid).then(function (_a) {
            var stockTotals = _a.stockTotals;
            _this.setState({ stockTotals: stockTotals });
        });
    };
    QuantityItem.prototype.render = function () {
        var _a;
        var _b = this.props, product = _b.product, handleClick = _b.handleClick, basket = _b.basket;
        var stockTotals = this.state.stockTotals;
        var countForProduct = ((_a = basket.items.find(function (item) { return item.productId === product.uuid; })) === null || _a === void 0 ? void 0 : _a.count) || 0;
        var uuid = product.uuid;
        return (React.createElement(ItemWrapper, null,
            React.createElement(Label, { id: id("label", this.props), large: true },
                product.name,
                this.isOutOfStock() && (React.createElement(Error, null,
                    React.createElement("br", null),
                    React.createElement(FormattedMessage, { id: "perks.components.quantityItem.outOfStock.error" }))),
                !this.isOutOfStock() && this.isLowInStock() && (React.createElement(Error, { style: { color: "grey" } },
                    React.createElement("br", null),
                    React.createElement(FormattedMessage, { id: "perks.components.quantityItem.stockLeft", values: { count: stockTotals[uuid] } })))),
            React.createElement(QuantityPicker, { id: id("picker", this.props), className: "pull-right", num: countForProduct, onClick: function (type) { return handleClick(type, uuid); }, disabled: this.isDisabled(), outOfStock: this.isOutOfStock() })));
    };
    return QuantityItem;
}(Component));
export default injectIntl(withBasket(QuantityItem));
